export default __webpack_public_path__ + "a26b563ae05fb505b22a9f68f94723a8.png";